import React from 'react';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import PropTypes from 'prop-types';
import { TM_PAYMENT_STATUS } from '@/modules/payments/contants/payments';

export const COLORS = ['#676767', '#dd0000', '#00C49F', '#0088FE'];
// Expects data: [{ paymentMethods, amount }]
const PieChartPagosPorEstados = ({ data = [] }) => {
  const hasData = data?.some(item => item.count > 0);
  
  const chartData = hasData ?
    data
      ?.sort((a, b) => (a._id || '').localeCompare(b._id || ''))
      ?.map(item => ({
        name: TM_PAYMENT_STATUS[item._id] || item._id || 'Desconocido',
        value: item.count,
      })) :
    [{ name: 'Sin datos', value: 1 }];
  
  return (
    <ResponsiveContainer width="100%" height={350}>
      <PieChart>
        <Pie
          data={chartData}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={100}
          label={
            hasData
              ? ({ name, percent }) => `${name}: ${(percent * 100).toFixed(1)}%`
              : false
          }
          labelLine={false}
        >
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={hasData ? COLORS[index % COLORS.length] : '#E5E7EB'} />
          ))}
        </Pie>
        <Tooltip formatter={(value) => value.toLocaleString()} />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};

PieChartPagosPorEstados.propTypes = {
  data: PropTypes.array,
};


export default PieChartPagosPorEstados;

